import axios from 'axios'
import { Project } from '../../types/project'

export const getProject = async (
  frontendId: string
): Promise<Project | null> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return null
    }

    const token = localStorage.getItem('@realize: accessToken')
    if (!token) {
      console.error('No authorization token found')
      return null
    }

    const response = await axios.get(`${backendUrl}/n8n/mavis/project`, {
      params: {
        frontend_id: frontendId
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    return (response.data as unknown) as Project
  } catch (error) {
    console.error('Unexpected error:', error)
    return null
  }
}
